import request from '@/utils/request'
import store from '@/store'
import { baseURL } from '@/config'

// 设备列表查询
export const apiTraceDeviceList = params => {
	return request({
		url: '/trace/device/list',
		method: 'GET',
		params,
	})
}
// 设备信息查询
export const apiTraceDeviceDetail = params => {
	return request({
		url: '/trace/device/detail',
		method: 'GET',
		params,
	})
}
// 设备告警记录查询
export const apiTraceAlarmList = params => {
	return request({
		url: '/trace/device/alarm/list',
		method: 'GET',
		params,
	})
}
// 通讯日志查询
export const apiTraceCommunicateLog = data => {
	return request({
		url: '/trace/communicate/log/list',
		method: 'POST',
		data,
	})
}

export const apiTraceCloseValveCmdList = (iotDeviceId, systemId) => {
	return request({
		url: `/trace/device/cmd-valve/list?iotDeviceId=${iotDeviceId}&systemId=${systemId}`,
		method: 'GET',
	})
}

export const parseTraceSseEvent = raw => {
	let event = 'message'
	const dataLines = []
	raw.split(/\r?\n/).forEach(line => {
		if (line.startsWith('event:')) event = line.slice(6).trim()
		if (line.startsWith('data:')) dataLines.push(line.slice(5).trimStart())
	})
	if (!dataLines.length) return null
	const text = dataLines.join('\n')
	try {
		return { event, data: JSON.parse(text) }
	} catch (error) {
		return { event, data: text }
	}
}

// 实时诊断使用 POST SSE，原生 fetch 便于逐块消费响应流。
export const apiTraceDeviceDiagnosisStream = async (data, handlers = {}, signal) => {
	const url = `${baseURL.replace(/\/$/, '')}/trace/device/diagnosis/stream`
	const headers = {
		Accept: 'text/event-stream, application/json',
		'Content-Type': 'application/json',
		'App-Namespace': 'iot-monitor',
	}
	if (store.getters.token) headers.accessToken = store.getters.token
	const response = await fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		headers,
		body: JSON.stringify(data),
		signal,
	})
	if (!response.ok) {
		const body = await response.json().catch(() => ({}))
		throw new Error(body.message || response.statusText || '通信链路诊断失败')
	}
	if (!response.body) throw new Error('服务响应格式异常，请稍后重试')

	const consume = raw => {
		const parsed = parseTraceSseEvent(raw)
		if (!parsed) return
		const callback = {
			rule_result: handlers.onRuleResult,
			ai_result: handlers.onAiResult,
			complete: handlers.onComplete,
			error: handlers.onError,
		}[parsed.event]
		if (callback) callback(parsed.data)
	}
	const reader = response.body.getReader()
	const decoder = new TextDecoder()
	let buffer = ''
	let done = false
	while (!done) {
		const chunk = await reader.read()
		done = chunk.done
		if (done) break
		buffer += decoder.decode(chunk.value, { stream: true })
		const events = buffer.split(/\r?\n\r?\n/)
		buffer = events.pop() || ''
		events.forEach(consume)
	}
	buffer += decoder.decode()
	if (buffer.trim()) consume(buffer.trim())
}
